// src/theme/index.js
import { createTheme } from '@mui/material/styles';

export const getDesignTokens = (mode) => ({
  palette: {
    mode,

    // Primary now has light, main, dark, and contrastText explicitly set:
    primary: {
      light: '#4D8CFF',    // your “lighter” blue
      main:  '#0055FF',    // your brand blue
      dark:  '#003FCC',    // a darker accent
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#33EFB4',
      main:  '#00CC99',
      dark:  '#009A74',
      contrastText: '#FFFFFF',
    },

    background: {
      default: mode === 'light' ? '#FFFFFF' : '#000000',
      paper:   mode === 'light' ? '#F4F6F8' : '#111111',
    },
    text: {
      primary:   mode === 'light' ? '#000000' : '#FFFFFF',
      secondary: mode === 'light' ? '#555555' : '#AAAAAA',
    },
  },

  typography: {
    fontFamily: '"Inter", sans-serif',
    h1:     { fontWeight: 800 },
    h2:     { fontWeight: 600 },
    h3:     { fontWeight: 500 },
    button: { textTransform: 'none' },
  },

  shape: { borderRadius: 8 },
});
